@use "../../styles/breakpoint.module.scss" as *;
@use "../../styles/layout.module.scss" as l;

.root {
    composes: repeater from "../../styles/layout.module.scss";
    grid-template-rows: [header-start] min-content [header-end] repeat(
            auto-fit,
            min-content
        );

    > header {
        grid-column: col-start 2 / col-end 11;
        margin-bottom: var(--spacer-40);

        @media ($below-tablet) {
            grid-column: content;
        }

        button {
            display: inline-block;
            margin-left: var(--spacer-24);
        }
    }
}

.body {
    grid-column: col-start 4 / col-end 9;
    grid-row-end: span var(--right-rail-count, 1);
    position: relative;

    @media ($below-tablet) {
        grid-column: col-start 2 / col-end 11;
    }

    @media ($below-mobile) {
        grid-column: content;
        margin-bottom: var(--spacer-40);
    }

    &:has(~ .card) {
        // Effectively spans 2 / 7, 8 is taken up by padding
        // Necessary to have 1 continuous line that spans the
        // height of the elements on the right
        grid-column: col-start 2 / col-end 8;
        padding-inline-end: l.span(1);

        @media ($below-tablet) {
            grid-column-start: content-start;
        }

        @media ($below-mobile) {
            grid-column: content;
            padding-bottom: var(--spacer-56);
            margin-bottom: var(--spacer-56);
        }

        &::after {
            content: "";
            position: absolute;
            inset-block: 0;
            right: calc(var(--spacer-gutter) / -2);

            --line: 1px solid var(--mid-gray);

            border-right: var(--line);

            @media ($below-mobile) {
                inset-inline: 0;
                top: 0;
                border-bottom: var(--line);
                border-right: 0;
            }
        }
    }
}

.card {
    grid-column: col-start 9 / col-end 11;

    @media ($below-tablet) {
        grid-column-end: content-end;
    }

    @media ($below-mobile) {
        grid-column: content;
    }

    &:not(:last-child) {
        margin-bottom: var(--spacer-40);
    }

    .link {
        margin-top: var(--spacer-24);
    }
}

.cardHeader {
    composes: fontHB40 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-16);
}

.eyebrow {
    composes: fontST20 from "../../styles/typography.module.scss";
    font-weight: bold;
}

.title {
    composes: fontHB104 from "../../styles/typography.module.scss";
    margin-block: var(--spacer-16) var(--spacer-24);
}

.updated {
    composes: fontST16 from "../../styles/typography.module.scss";
}

.prevNext {
    composes: base from "../Clickables/index.module.scss";
    composes: fontST16 from "../../styles/typography.module.scss";
    display: grid;
    gap: var(--spacer-12);
    margin-top: var(--spacer-64);
    align-items: start;

    --thumb-width: 152px;

    svg {
        margin: 0;
        width: var(--spacer-24);
        height: var(--spacer-24);
    }

    .img {
        grid-area: thumbnail;
        display: grid;
        grid-template-columns: subgrid;
        align-items: center;

        img {
            max-width: var(--thumb-width);
        }
    }

    .text {
        grid-area: text;
        display: flex;
        flex-direction: column;
        gap: var(--spacer-8);

        & > :first-child {
            font-weight: bold;
        }
    }
}

.prev {
    composes: prevNext;
    grid-column: col-start 2 / col-end 6;
    grid-template-columns:
        [thumbnail-start] max-content var(--thumb-width)
        [thumbnail-end text-start] 1fr [text-end];

    @media ($below-tablet) {
        grid-template-columns: [thumbnail-start] min-content [text-start] 1fr [text-end thumbnail-end];
        grid-template-rows: [thumbnail-start] min-content [thumbnail-end text-start] min-content [text-end];
        grid-column: col-start 1 / col-end 6;
    }

    @media ($below-mobile) {
        grid-column: 1 / col-end 3;
        padding-left: var(--spacer-16);
    }

    svg {
        rotate: 180deg;
    }
}

.next {
    composes: prevNext;
    grid-column: col-start 7 / col-end 11;
    grid-template-columns:
        [text-start] 1fr [text-end thumbnail-start] var(--thumb-width)
        max-content [thumbnail-end];

    @media ($below-tablet) {
        grid-template-columns: [thumbnail-start text-start] 1fr [text-end] min-content [thumbnail-end];
        grid-template-rows: [thumbnail-start] min-content [thumbnail-end text-start] min-content [text-end];
        grid-column: col-start 7 / col-end 12;
    }

    @media ($below-mobile) {
        grid-column: col-start 4 / -1;
        padding-right: var(--spacer-16);
    }

    .img {
        justify-self: end;

        img {
            justify-self: end;
        }
    }

    .text {
        text-align: right;
    }
}
